import request from '@/api/request'

/**
 * 管理端查询考试配置列表
 */

export const getListTestConf = (params) => {
  return request({
    url: 'product/adm/testConf/getListTestConf',
    params,
    method: 'get'
  })
}

/**
 * 管理端查询考试配置列表
 */

export const updateTestConf  = (data) => {
  return request({
    url: 'product/adm/testConf/updateTestConf',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 管理端查询考试配置列表(考场列表)
 */

export const getListTestPlan  = (data) => {
  return request({
    url: 'product/adm/testPlan/page',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 管理端添加考试计划(考场添加)
 */

export const addTestPlan  = (data) => {
  return request({
    url: 'product/adm/testPlan/add',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 管理端更新考试计划(考场编辑)
 */

export const updateTestPlan  = (data) => {
  return request({
    url: 'product/adm/testPlan/update',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 管理端禁用启用考试计划(考场编辑)
 */

export const updateStatus = (data) => {
  return request({
    url: 'product/adm/testPlan/updateStatus',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 发布考场成绩
 */

export const updateAchievement  = (data) => {
  return request({
    url: 'product/adm/testPlan/updateAchievement',
    data,
    method: 'post',
    type: 'json'
  })
}
